import { render, staticRenderFns } from "./business_users.vue?vue&type=template&id=7b5a4bfa&scoped=true&"
import script from "./business_users.vue?vue&type=script&lang=js&"
export * from "./business_users.vue?vue&type=script&lang=js&"
import style0 from "./business_users.vue?vue&type=style&index=0&id=7b5a4bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5a4bfa",
  null
  
)

export default component.exports